import React, { useEffect } from 'react';

import LeftSideBar from './LeftSideBar';

import { connect, useSelector } from 'react-redux';
import { getInProgressRooms } from '../redux/room/room.actions';
import LeftSideBarCompact from './LeftSideBarCompact/index';
import { useState } from 'react';
import ToggleButton from './ToggleButton';
import { Grid, Fab, Dialog, DialogTitle, DialogContent, Tooltip, Box, Typography, Button, Chip, IconButton, Paper, useTheme, Zoom, Fade, Divider, Rating } from '@mui/material';
import { alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { useLocation, useHistory } from 'react-router-dom';
import discoveryIconWhite from '../assets/icons/discovery_icon_white.png';
import discoveryIconBlack from '../assets/icons/discovery_icon_black.png';
import ClientSearch from '../components/ClientSearch';
import NotificationBadge from '../components/NotificationBadge';
import TicketAlertsPanel from '../components/TicketAlertsPanel';
import ProfileMenu from './ProfileMenu';
import QuickAccessItems from '../components/QuickAccessItems';
import AvisosTemporarios from '../components/AvisosTemporarios';
import NewAssignedChatWatcher from '../components/NewAssignedChatWatcher';
import AIAssistant from '../components/AIAssistant';
import { getUser, getUserIndicators, getUsers, logOut, selectPermissions, setPermissions } from '../redux/user/user.actions';
import { getServiceGroups } from '../redux/serviceGroup/serviceGroup.actions';
import { getProfiles } from '../redux/profile/profile.actions';
import { selectLoading, setLoading, setNotLoading } from '../redux/loading/loading.actions';
import Spinner from '../components/Spinner';
import { fetchFields } from '../redux/field/field.actions';
import { runOnceAppBootstrap } from '../utils/appBootstrapGate';
// import useChat from '../services/socket';

/*
 * A barra do topo.
 *
 * Mesmo fundo da barra lateral (`--sidebar-shell-bg`, navy nos dois temas),
 * e e justamente esse o problema que este degrade resolve: encostadas uma na
 * outra, as duas barras chapadas na mesma cor viravam um unico bloco em L, e
 * o canto onde se encontram sumia. O clareado sutil da esquerda para a
 * direita da ao topo uma direcao propria, sem introduzir cor nova.
 *
 * O fio de baixo usa a cor de acento a 20%: separa o shell do conteudo sem o
 * degrau que uma sombra criaria sobre a primeira linha da tela.
 */
const shellTopBarBackground = {
  backgroundColor: 'var(--sidebar-shell-bg)',
  backgroundImage:
    'linear-gradient(90deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.015) 38%, rgba(255, 255, 255, 0) 100%)',
  borderBottom: '1px solid',
  borderBottomColor: 'rgba(139, 196, 237, 0.2)',
};

/*
 * Sino, alertas de chamado e avisos temporarios ficam numa pilula so.
 *
 * Soltos, os tres ficavam a meio caminho entre a aba da esquerda e o avatar
 * da direita, sem pertencer a nenhum dos dois -- e o avatar, que e o unico
 * controle de conta ali, nao se distinguia deles. Agrupados, o lado direito
 * passa a ter duas coisas (avisos | voce) em vez de quatro soltas.
 */
const shellTopBarActionCluster = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.25,
  px: 0.5,
  borderRadius: '999px',
  backgroundColor: 'rgba(255, 255, 255, 0.07)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  /*
   * No estreito a pilula sai de cena. Ela custa 10px de largura, e a barra do
   * topo JA transborda em 375px (429px de conteudo medidos antes desta
   * mudanca): agrupar ali so empurraria o avatar mais para fora da tela. O
   * agrupamento resolve um problema de leitura que so existe quando sobra
   * espaco.
   */
  '@media (max-width: 768px)': {
    px: 0,
    backgroundColor: 'transparent',
    border: 'none',
  },
};

/*
 * Uma acao do botao flutuante: rotulo a esquerda, botao redondo a direita.
 *
 * ## O rotulo nao e enfeite
 *
 * As acoes eram tres circulos escuros identicos, empilhados, e o que cada um
 * fazia so aparecia no tooltip -- que exige parar o mouse em cima de um
 * botao para descobrir se e o que se procura. Com tres, isso e ate tres
 * paradas antes do primeiro clique. O rotulo escrito ao lado resolve a
 * escolha antes dela: le-se a coluna inteira de uma vez.
 *
 * O tooltip SAIU junto com a chegada do rotulo. Mantidos os dois, o tooltip
 * repetiria exatamente a palavra ja escrita a 12px dali.
 *
 * ## Por que as acoes nao sao da cor primaria
 *
 * Eram quatro circulos da mesma cor, do mesmo tamanho: o gatilho e as acoes
 * que ele abre pesavam igual, e nada dizia qual deles abre os outros. As
 * acoes passam a ser claras, com o icone na cor de acento; o gatilho fica
 * sendo o unico circulo cheio de cor na tela.
 *
 * O tamanho nao entra nessa distincao porque nao e nosso: a folha global
 * (AppThemeGlobalStyles) prende TODO `.MuiFab-root` em 44px com `!important`
 * -- faz parte da compactacao da interface inteira. Brigar com ela aqui
 * deixaria este canto fora da densidade do resto do app.
 */
const AcaoDoFab = ({ visivel, atraso, rotulo, onClick, children }) => (
  <Zoom
    in={visivel}
    timeout={200}
    style={{ transitionDelay: visivel ? `${atraso}ms` : '0ms' }}
    unmountOnExit
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, pointerEvents: 'auto' }}>
      <Box
        sx={{
          px: 1.25,
          py: 0.5,
          borderRadius: 1.5,
          fontSize: '0.78rem',
          fontWeight: 600,
          whiteSpace: 'nowrap',
          color: 'text.primary',
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
        }}
      >
        {rotulo}
      </Box>
      <Fab
        aria-label={rotulo}
        onClick={onClick}
        sx={{
          color: 'primary.main',
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          boxShadow: '0 4px 14px rgba(0, 0, 0, 0.16)',
          transition: 'background-color 200ms, color 200ms, transform 200ms',
          '&:hover': {
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            transform: 'scale(1.06)',
          },
        }}
      >
        {children}
      </Fab>
    </Box>
  </Zoom>
);

const Template = ({ Page, ...props }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const theme = useTheme();
  const history = useHistory();

  // Carregar estado do menu do localStorage ou usar false como padrão
  const [open, setOpen] = useState(false)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const savedState = localStorage.getItem('sidebarCollapsed');
    return savedState ? JSON.parse(savedState) : false;
  })
  const [clientSearchOpen, setClientSearchOpen] = useState(false)
  const [selectedClient, setSelectedClient] = useState(null)
  const [fabExpanded, setFabExpanded] = useState(false)
  const [operatorsTabActive, setOperatorsTabActive] = useState(false)
  const [aiAssistantOpen, setAiAssistantOpen] = useState(false)
  // Painel lateral do Orby (desktop). Estado persistido: fica aberto entre telas/refresh.
  const [orbyPanelOpen, setOrbyPanelOpen] = useState(() => {
    try { return localStorage.getItem('orbyPanelOpen') === '1'; } catch { return false; }
  })
  // Largura do painel do Orby (redimensionável, persistida).
  const [orbyPanelWidth, setOrbyPanelWidth] = useState(() => {
    try { const w = parseInt(localStorage.getItem('orbyPanelWidth'), 10); return (w >= 320 && w <= 900) ? w : 420; } catch { return 420; }
  })
  const orbyResizingRef = React.useRef(false)
  const permissions = useSelector(selectPermissions);
  const canViewFinancialInfo = permissions?.includes('#view-financial-info') || false;
  const canViewClientSearch = permissions?.includes('/clientes/pesquisa') || false;
  const isLoading = useSelector(selectLoading);
  const location = useLocation();

  // Função para alternar o estado do menu e salvar no localStorage
  const handleToggleSidebar = () => {
    setSidebarCollapsed(prev => {
      const newState = !prev;
      localStorage.setItem('sidebarCollapsed', JSON.stringify(newState));
      return newState;
    });
  };

  // Listener para detectar quando a aba de operadores está ativa
  useEffect(() => {
    const handleOperatorsTabChange = (event) => {
      setOperatorsTabActive(event.detail.active);
    };

    window.addEventListener('operatorsTabChanged', handleOperatorsTabChange);
    return () => {
      window.removeEventListener('operatorsTabChanged', handleOperatorsTabChange);
    };
  }, []);

  // Listener para abrir o Orby quando o FAB for clicado (modal — usado no celular)
  useEffect(() => {
    const handleOpenAIAssistant = () => {
      setAiAssistantOpen(true);
    };

    window.addEventListener('openAIAssistant', handleOpenAIAssistant);
    return () => {
      window.removeEventListener('openAIAssistant', handleOpenAIAssistant);
    };
  }, []);

  // Persiste o estado do painel do Orby.
  useEffect(() => {
    try { localStorage.setItem('orbyPanelOpen', orbyPanelOpen ? '1' : '0'); } catch { /* ignore */ }
  }, [orbyPanelOpen]);

  // Persiste a largura do painel do Orby.
  useEffect(() => {
    try { localStorage.setItem('orbyPanelWidth', String(orbyPanelWidth)); } catch { /* ignore */ }
  }, [orbyPanelWidth]);

  // Arrastar a divisória redimensiona o painel do Orby (entre 320px e 60% da tela).
  const startOrbyResize = (e) => {
    e.preventDefault();
    orbyResizingRef.current = true;
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';
    const onMove = (ev) => {
      if (!orbyResizingRef.current) return;
      const vw = window.innerWidth;
      const max = Math.min(900, Math.floor(vw * 0.6));
      setOrbyPanelWidth(Math.max(320, Math.min(max, vw - ev.clientX)));
    };
    const onUp = () => {
      orbyResizingRef.current = false;
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  };

  // Abre o Orby a partir da aba do acesso rápido (ou do FAB): no desktop alterna o
  // painel lateral; no celular abre o modal (não cabe lado a lado). Lê a largura na
  // hora do clique para não usar valor defasado.
  const openOrby = () => {
    if (window.innerWidth > 768) {
      setOrbyPanelOpen((v) => !v);
    } else {
      setAiAssistantOpen(true);
    }
  };
  useEffect(() => {
    const handler = () => openOrby();
    window.addEventListener('orbyTabClick', handler);
    return () => window.removeEventListener('orbyTabClick', handler);
  }, []);

  // const { messages, sendMessage } = useChat(1, props.getInProgressRooms); // Creates a websocket and manages messaging

  // useEffect(() => {
  //     if (!("Notification" in window)) {
  //         console.log("This browser does not support desktop notification");
  //       } else {
  //         Notification.requestPermission();
  //       }
  // }, []);
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth
  })

  useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    }

    window.addEventListener('resize', handleResize)

    if (dimensions.width > 768)
      setOpen(false)
    return _ => {
      window.removeEventListener('resize', handleResize)
    }
  }, [dimensions.width])

  useEffect(() => {
    const runBootstrap = () => {
      runOnceAppBootstrap(() => {
        let u = null;
        try {
          u = JSON.parse(localStorage.getItem('user') || 'null');
        } catch {
          u = null;
        }

        props.getUsers();
        props.getServiceGroups();
        props.getUserIndicators();
        props.getProfiles();
        props.fetchFields();
        if (u?.id) {
          props.getInProgressRooms(u.id);
        }
        // Sockets das salas: LeftSideBar já reconecta quando `inProgressRooms` muda no Redux
        if (u?.id) {
          props.getUser(u.id);
        }
      });
    };

    // `load` pode já ter disparado antes do React montar (refresh em rotas internas).
    if (document.readyState === 'complete') {
      runBootstrap();
    } else {
      window.addEventListener('load', runBootstrap);
      return () => window.removeEventListener('load', runBootstrap);
    }
    // Props de dispatch do connect são estáveis; evitar [props] — remontagens do Template
    // (Route com component={() => <Template />}) disparariam o bootstrap de novo.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isLoading) {
      const shouldLogOut = !user || !permissions || permissions.length === 0;
      if (shouldLogOut) {
        // props.logOut();
      }
    }
  }, [isLoading, user, permissions, props]);

  const expandedSidebarWidth = 176;
  const collapsedSidebarWidth = 76;

  return (
    <>
      {/* Abre/pisca aba no QuickAccess quando um chat é atribuído automaticamente (item 8). */}
      <NewAssignedChatWatcher />
      {dimensions.width <= 768
        ?
        /* `xs` é prop de item; em container o MUI avisa. Os três valores
           abaixo são o que o `xs={12}` gerava -- ver
           `src/avisosDoConsole.test.js`. */
        <Grid container flexDirection={'row'} flexWrap={'nowrap'} sx={{ flexBasis: '100%', flexGrow: 0, maxWidth: '100%' }} >
          <Grid item xs className={'left-sidebar'}>
            <Grid style={{ position: 'sticky', top: 0 }}>
              <ToggleButton open={open} setOpen={setOpen} />
              <LeftSideBarCompact open={open} setOpen={setOpen} />
              {/* <Grid style={{backgroundColor: '#2A4D69', width: '8.2%', height: '100%', position: 'fixed'}}>
                  </Grid> */}
            </Grid>
          </Grid>
          <Grid item xs={11} sx={{ display: 'flex', flexDirection: 'column' }}>
            {/* Header Global */}
            <Paper
              elevation={0}
              sx={{
                ...shellTopBarBackground,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                px: 2,
                py: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 1.5,
                zIndex: 1000,
              }}
            >
              {/* Acessos Rápidos */}
              <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                <QuickAccessItems />
              </Box>

              {/* Notificações e Perfil */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={shellTopBarActionCluster}>
                  {/* Notificações */}
                  <Tooltip title="Notificações" arrow placement="bottom">
                    <Box sx={{ display: 'flex' }}>
                      <NotificationBadge />
                    </Box>
                  </Tooltip>
                  <TicketAlertsPanel />
                  {/* Os avisos temporarios (Gisele, 19/10): ao LADO do sino, e o
                      icone some sozinho quando nao ha nenhum. */}
                  <AvisosTemporarios />
                </Box>

                <ProfileMenu size="small" />
              </Box>
            </Paper>

            <Box sx={{ flex: 1, minHeight: 0, display: 'flex', overflow: 'hidden' }}>
              <Box sx={{ flex: 1, minWidth: 0, overflow: 'auto' }}>
                <Page {...props} dimensions={dimensions} />
              </Box>
              {dimensions.width > 768 && (
                <>
                  {orbyPanelOpen && (
                    <Box
                      onMouseDown={startOrbyResize}
                      sx={{
                        width: '6px',
                        flexShrink: 0,
                        cursor: 'col-resize',
                        bgcolor: 'divider',
                        transition: 'background-color 0.15s',
                        '&:hover': { bgcolor: 'primary.main' },
                      }}
                    />
                  )}
                  {/* Painel SEMPRE montado (só escondido quando fechado) para preservar a
                      conversa e o feedback ao fechar/reabrir — antes desmontava e resetava. */}
                  <Box
                    sx={{
                      width: orbyPanelOpen ? orbyPanelWidth : 0,
                      flexShrink: 0,
                      height: '100%',
                      overflow: 'hidden',
                      display: orbyPanelOpen ? 'block' : 'none',
                    }}
                  >
                    <AIAssistant variant="panel" open onClose={() => setOrbyPanelOpen(false)} />
                  </Box>
                </>
              )}
            </Box>
          </Grid>
          {/* <RightSideBar dimensions={dimensions}/> */}
        </Grid>
        :
        <Grid item container flexDirection={'row'} flexWrap={'nowrap'} xs={12}>
          <Spinner />
          {/* <Grid style={{position: 'sticky', top: 0}}> */}
          <Grid
            item
            sx={{
              flex: '0 0 auto',
              width: sidebarCollapsed ? collapsedSidebarWidth : expandedSidebarWidth,
              maxWidth: sidebarCollapsed ? collapsedSidebarWidth : expandedSidebarWidth,
              transition: 'width 0.3s ease',
              backgroundColor: 'transparent'
            }}
          >
            <LeftSideBar
              dimensions={dimensions}
              toggleTheme={props.toggleTheme}
              isCollapsed={sidebarCollapsed}
              onToggleSidebar={handleToggleSidebar}
            />
          </Grid>
          <Grid
            item
            xs
            sx={{ flex: '1 1 auto', transition: 'padding 0.3s ease', px: { lg: 0 }, display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}
          >
            {/* Header Global */}
            <Paper
              elevation={0}
              sx={{
                ...shellTopBarBackground,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                px: 2,
                py: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 1.5,
                zIndex: 1000,
                flexShrink: 0,
              }}
            >
              {/* Acessos Rápidos */}
              <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                <QuickAccessItems />
              </Box>

              {/* Notificações e Perfil */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={shellTopBarActionCluster}>
                  {/* Notificações */}
                  <Tooltip title="Notificações" arrow placement="bottom">
                    <Box sx={{ display: 'flex' }}>
                      <NotificationBadge />
                    </Box>
                  </Tooltip>
                  <TicketAlertsPanel />
                  <AvisosTemporarios />
                </Box>

                <ProfileMenu size="medium" />
              </Box>
            </Paper>

            <Box sx={{ flex: 1, minHeight: 0, display: 'flex', overflow: 'hidden' }}>
              <Box sx={{ flex: 1, minWidth: 0, overflow: 'auto' }}>
                <Page {...props} dimensions={dimensions} />
              </Box>
              {dimensions.width > 768 && (
                <>
                  {orbyPanelOpen && (
                    <Box
                      onMouseDown={startOrbyResize}
                      sx={{
                        width: '6px',
                        flexShrink: 0,
                        cursor: 'col-resize',
                        bgcolor: 'divider',
                        transition: 'background-color 0.15s',
                        '&:hover': { bgcolor: 'primary.main' },
                      }}
                    />
                  )}
                  {/* Painel SEMPRE montado (só escondido quando fechado) para preservar a
                      conversa e o feedback ao fechar/reabrir — antes desmontava e resetava. */}
                  <Box
                    sx={{
                      width: orbyPanelOpen ? orbyPanelWidth : 0,
                      flexShrink: 0,
                      height: '100%',
                      overflow: 'hidden',
                      display: orbyPanelOpen ? 'block' : 'none',
                    }}
                  >
                    <AIAssistant variant="panel" open onClose={() => setOrbyPanelOpen(false)} />
                  </Box>
                </>
              )}
            </Box>
          </Grid>
          {/* <RightSideBar dimensions={dimensions}/> */}
        </Grid>
      }

      {/*
        * O vidro atras das acoes abertas.
        *
        * Sem ele, a coluna de acoes flutuava sobre uma tela que continuava
        * inteira clicavel: o painel estava ABERTO e nada na tela dizia isso,
        * entao sair dele exigia acertar de novo o mesmo botao de 44px. Com o
        * veu, qualquer ponto da tela fecha -- e a coluna passa a se ler como
        * camada temporaria, nao como mais um enfeite fixo do canto.
        *
        * `unmountOnExit` porque um veu invisivel que fica montado por cima da
        * aplicacao e uma armadilha classica: basta um `pointerEvents` errado
        * em alguma refatoracao futura para a tela inteira parar de responder
        * sem ninguem entender por que.
        */}
      <Fade in={fabExpanded} timeout={200} unmountOnExit>
        <Box
          onClick={() => setFabExpanded(false)}
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 1299,
            display: location.pathname.startsWith('/chat') ? 'none' : 'block',
            bgcolor: alpha('#0f172a', 0.32),
            backdropFilter: 'blur(2px)',
          }}
        />
      </Fade>

      {/* FAB Principal Animado (oculto na tela de Chat, onde colide com a caixa de mensagem) */}
      <Box
        sx={{
          position: 'fixed',
          bottom: dimensions.width <= 768 ? 16 : 24,
          right: dimensions.width <= 768 ? 16 : 24,
          zIndex: 1300,
          display: location.pathname.startsWith('/chat') ? 'none' : 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: 1.5,
          pointerEvents: 'none',
        }}
      >
        {/*
          * "Adicionar operador" VEIO para a coluna (29/10/2026).
          *
          * Ele ficava sozinho a ESQUERDA do botao principal, numa linha
          * propria, enquanto as outras tres acoes subiam em coluna. Na tela de
          * Operadores isso dava duas direcoes de leitura para o mesmo gesto --
          * e, agora que cada acao carrega seu rotulo a esquerda, os rotulos da
          * coluna passariam POR CIMA dele.
          *
          * Na coluna ele e so mais uma acao, que e o que sempre foi.
          */}
        {operatorsTabActive && (
          <AcaoDoFab
            visivel={fabExpanded}
            atraso={100}
            rotulo="Adicionar operador"
            onClick={() => {
              // Dispara evento customizado para abrir o modal de operador
              window.dispatchEvent(new CustomEvent('openOperatorModal'));
              setFabExpanded(false);
            }}
          >
            <PersonAddIcon />
          </AcaoDoFab>
        )}

        {canViewClientSearch && (
          <AcaoDoFab
            visivel={fabExpanded}
            atraso={100}
            rotulo="Pesquisar cliente"
            onClick={() => {
              setClientSearchOpen(true);
              setFabExpanded(false);
            }}
          >
            <SearchIcon />
          </AcaoDoFab>
        )}

        <AcaoDoFab
          visivel={fabExpanded}
          atraso={150}
          rotulo="Novo ticket"
          onClick={() => {
            history.push('/ticket/new');
            setFabExpanded(false);
          }}
        >
          <NoteAddIcon />
        </AcaoDoFab>

        <AcaoDoFab
          visivel={fabExpanded}
          atraso={200}
          rotulo="Orby"
          onClick={() => {
            openOrby();
            setFabExpanded(false);
          }}
        >
          {/*
            * O icone segue trocando com o tema porque o fundo do botao agora e
            * o do papel: claro no tema claro (pede o icone preto), escuro no
            * escuro (pede o branco). A regra antiga continua valendo, so que
            * agora pelo motivo certo.
            */}
          <Box
            component="img"
            src={theme.palette.mode === 'dark' ? discoveryIconWhite : discoveryIconBlack}
            alt="Orby"
            sx={{ width: 26, height: 26, objectFit: 'contain' }}
          />
        </AcaoDoFab>

        {/*
          * O gatilho.
          *
          * ## O "+" que continuava "+" depois de abrir
          *
          * O botao trocava o icone de `Add` para `Close` E girava 45 graus ao
          * mesmo tempo. Um X girado 45 graus e um +: aberto ou fechado, o
          * desenho na tela era o MESMO. Quem olhasse o botao nao tinha como
          * saber em que estado estava -- so o tooltip (que pede hover) e as
          * acoes aparecendo denunciavam.
          *
          * Agora o icone e sempre `Add`, e e o giro que faz o trabalho: 135
          * graus levam o + a virar X de verdade, com o movimento visivel. Uma
          * transformacao so, uma leitura so.
          *
          * ## A sombra tem a cor do botao
          *
          * A sombra cinza padrao do MUI e a mesma debaixo de qualquer
          * elemento. Tingida da cor primaria, o botao parece apoiado acima da
          * tela em vez de colado nela -- e e o unico circulo cheio de cor que
          * sobrou, o que ja o separa das acoes claras que ele abre.
          */}
        <Tooltip title={fabExpanded ? 'Fechar' : 'Ações rápidas'} placement="left" arrow>
          <Fab
            color="primary"
            aria-label="main-fab"
            onClick={() => setFabExpanded(!fabExpanded)}
            sx={{
              pointerEvents: 'auto',
              backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.light || theme.palette.primary.main, 0.95)} 0%, ${theme.palette.primary.main} 55%, ${theme.palette.primary.dark || theme.palette.primary.main} 100%)`,
              boxShadow: `0 8px 20px ${alpha(theme.palette.primary.main, 0.45)}`,
              transition: 'transform 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms',
              transform: fabExpanded ? 'rotate(135deg)' : 'rotate(0deg)',
              '&:hover': {
                boxShadow: `0 10px 26px ${alpha(theme.palette.primary.main, 0.6)}`,
                transform: fabExpanded ? 'rotate(135deg) scale(1.06)' : 'scale(1.06)',
              },
            }}
          >
            <AddIcon />
          </Fab>
        </Tooltip>
      </Box>

      {/* Modal com Orby */}
      <AIAssistant 
        open={aiAssistantOpen} 
        onClose={() => setAiAssistantOpen(false)} 
      />

      {/* Modal com ClientSearch */}
      <Dialog open={clientSearchOpen} onClose={() => setClientSearchOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Pesquisar Cliente</DialogTitle>
        <DialogContent>
          <ClientSearch
            selectedClient={selectedClient}
            onClientSelect={(client) => {
              setSelectedClient(client);
            }}
          />
          {selectedClient && selectedClient.company && (
            <Box sx={{ mt: 3 }}>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 700 }}>
                Informações do Cliente
              </Typography>

              {/* Código */}
              {selectedClient.company?.code && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>Código</Typography>
                  <Typography variant="body2" color="text.secondary">{selectedClient.company.code}</Typography>
                </Box>
              )}

              {/* Razão Social / Nome Fantasia */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                  Cliente: {selectedClient.company?.code || ''}-{selectedClient.company?.business_name || selectedClient.company?.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Razão: {selectedClient.company?.business_name || selectedClient.company?.name}
                </Typography>
                {selectedClient.company?.name && selectedClient.company.name !== selectedClient.company?.business_name && (
                  <Typography variant="body2" color="text.secondary">
                    Nome Fantasia: {selectedClient.company.name}
                  </Typography>
                )}
                {selectedClient.company?.cnpj && (
                  <Typography variant="body2" color="text.secondary">CNPJ: {selectedClient.company.cnpj}</Typography>
                )}
              </Box>

              {/* Contato (nome do cliente) */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>Contato</Typography>
                <Typography variant="body2" color="text.secondary">
                  {selectedClient.name || '-'}
                  {selectedClient.email ? ` - Email: ${selectedClient.email}` : ''}
                  {selectedClient.company?.phone ? ` - Telefone: (${selectedClient.company?.area_code || ''}) ${selectedClient.company.phone}` : ''}
                </Typography>
              </Box>

              {(() => {
                const rawId = selectedClient?.id;
                const idNum = rawId != null && rawId !== '' ? Number(rawId) : NaN;
                const canGo = !Number.isNaN(idNum) && idNum > 0;
                if (!canGo) return null;
                return (
                  <Box sx={{ mb: 2 }}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        setClientSearchOpen(false);
                        history.push(`/cliente/${idNum}/tickets`);
                      }}
                      sx={{ textTransform: 'none', borderRadius: 2, fontWeight: 600 }}
                    >
                      Ver tickets deste cliente
                    </Button>
                  </Box>
                );
              })()}

              {/* Endereço completo (igual ao ticket, com bairro) */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>Endereço</Typography>
                <Typography variant="body2" color="text.secondary">
                  {(() => {
                    const c = selectedClient.company;
                    if (!c) return '-';
                    const parts = [];
                    if (c.address) {
                      const addr = c.address.replace(/^(Rua|Av|Avenida|Rod|Rodovia|Al|Alameda|Trav|Travessa|Pça|Praça|Est|Estrada)\s+/i, '').trim();
                      if (addr) parts.push(addr);
                    }
                    if (c.number) parts.push(`nº ${c.number}`);
                    if (c.district) parts.push(c.district);
                    if (c.city && c.state) parts.push(`${c.city}/${c.state}`);
                    else if (c.city) parts.push(c.city);
                    else if (c.state) parts.push(c.state);
                    if (c.zip_code) parts.push(`CEP: ${c.zip_code}`);
                    return parts.length > 0 ? parts.join(', ') : '-';
                  })()}
                </Typography>
              </Box>

              {/* Classificação */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>Classificação</Typography>
                {(() => {
                  const classificacao = selectedClient.company?.classificacao || selectedClient.company?.classification;
                  if (classificacao != null && classificacao >= 1 && classificacao <= 5) {
                    return <Rating value={parseInt(classificacao)} max={5} readOnly size="small" />;
                  }
                  return <Typography variant="body2" color="text.secondary" fontStyle="italic">Sem classificação</Typography>;
                })()}
              </Box>

              {/* Versão em Uso (igual ao ticket) */}
              {(selectedClient.company?.version_in_use || selectedClient.company?.product_description) && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>Versão em Uso</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {selectedClient.company?.product_description || '-'}
                    {selectedClient.company?.version_in_use && ` - ${selectedClient.company.version_in_use}`}
                  </Typography>
                </Box>
              )}

              {/* Fatura (com Total e Dia Pagamento, igual ao ticket) */}
              {canViewFinancialInfo ? (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>Fatura</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Mensalidade: R$ {(parseFloat(String(selectedClient.company?.valor_mensalidade || selectedClient.company?.valorMensalidade || selectedClient.company?.monthly_fee || 0).replace(',', '.')) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    {' | '}
                    Módulos: R$ {(parseFloat(String(selectedClient.company?.valor_modulos || selectedClient.company?.valorModulos || 0).replace(',', '.')) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    {' | '}
                    Desconto: R$ {(parseFloat(String(selectedClient.company?.valor_desconto || selectedClient.company?.valorDesconto || 0).replace(',', '.')) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, mt: 0.5 }}>
                    Total: R$ {(
                      (parseFloat(String(selectedClient.company?.valor_mensalidade || selectedClient.company?.valorMensalidade || selectedClient.company?.monthly_fee || 0).replace(',', '.')) || 0) +
                      (parseFloat(String(selectedClient.company?.valor_modulos || selectedClient.company?.valorModulos || 0).replace(',', '.')) || 0) -
                      (parseFloat(String(selectedClient.company?.valor_desconto || selectedClient.company?.valorDesconto || 0).replace(',', '.')) || 0)
                    ).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </Typography>
                  {selectedClient.company?.dia_pagamento && (
                    <Typography variant="body2" color="text.secondary">
                      Dia Pagamento: {selectedClient.company.dia_pagamento}
                    </Typography>
                  )}
                </Box>
              ) : (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="text.secondary" fontStyle="italic">
                    Informações financeiras ocultas para o seu perfil.
                  </Typography>
                </Box>
              )}

              {/* Módulos Ativos (igual ao ticket) */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>Módulos Ativos</Typography>
                {(() => {
                  let modulesArray = [];
                  const company = selectedClient.company;
                  if (company.active_modules) {
                    try {
                      if (typeof company.active_modules === 'string') {
                        const trimmed = company.active_modules.trim();
                        if (trimmed && trimmed !== '[]' && trimmed !== 'null') {
                          const parsed = JSON.parse(trimmed);
                          modulesArray = Array.isArray(parsed) ? parsed : [parsed];
                        }
                      } else if (Array.isArray(company.active_modules)) modulesArray = company.active_modules;
                    } catch (e) {
                      const strValue = String(company.active_modules).trim();
                      if (strValue && strValue !== '[]') modulesArray = [company.active_modules];
                    }
                  }
                  if (modulesArray.length === 0 && company.modules) {
                    const m = company.modules;
                    modulesArray = Array.isArray(m) ? m : (typeof m === 'string' && m.trim() ? [m] : []);
                  }
                  modulesArray = modulesArray.filter(m => m != null && String(m).trim() !== '');
                  if (modulesArray.length === 0) {
                    return <Typography variant="body2" color="text.secondary" fontStyle="italic">Nenhum módulo ativo</Typography>;
                  }
                  return <Typography variant="body2" color="text.secondary">{modulesArray.join(', ')}</Typography>;
                })()}
              </Box>

              {/* Credenciais do Site (igual ao ticket) */}
              {(selectedClient.company?.usuario_site || selectedClient.company?.senha_site) && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>Credenciais do Site</Typography>
                  {selectedClient.company?.usuario_site && (
                    <Typography variant="body2" color="text.secondary">Usuário: {selectedClient.company.usuario_site}</Typography>
                  )}
                  {selectedClient.company?.senha_site && (
                    <Typography variant="body2" color="text.secondary">Senha: {selectedClient.company.senha_site}</Typography>
                  )}
                </Box>
              )}

              {/* Situação (sempre exibir, igual ao ticket) */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>Situação</Typography>
                <Chip
                  label={(() => {
                    const activeStatus = selectedClient.company?.active;
                    switch (activeStatus) {
                      case 'S': return 'Ativo';
                      case 'N': return 'Bloqueado';
                      case 'C': return 'Cancelado';
                      case 'T': return 'Inativo';
                      default: return selectedClient.company?.status === 1 ? 'Ativo' : 'Desconhecido';
                    }
                  })()}
                  color={
                    selectedClient.company?.active === 'S' ? 'success' :
                    selectedClient.company?.active === 'N' ? 'warning' :
                    selectedClient.company?.active === 'C' ? 'error' :
                    'default'
                  }
                  size="small"
                />
              </Box>

              {/* Representante */}
              {selectedClient.company?.service_group_description && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>Representante</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {selectedClient.company.service_group_description}
                  </Typography>
                </Box>
              )}

              {/* Última Sincronização (igual ao ticket) */}
              {selectedClient.company?.sync_date && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>Última Sincronização</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {new Date(selectedClient.company.sync_date).toLocaleString('pt-BR', {
                      day: '2-digit', month: '2-digit', year: 'numeric',
                      hour: '2-digit', minute: '2-digit'
                    }).replace(', ', ' ')}
                  </Typography>
                </Box>
              )}

              {/* Ações */}
              <Box sx={{ display: 'flex', gap: 1, mt: 3, pt: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    const company = selectedClient.company || {};
                    const client = selectedClient || {};
                    
                    // Construir texto completo com todos os dados disponíveis
                    const dataLines = [];
                    
                    // Dados básicos
                    dataLines.push(`Cliente: ${company.code || ''}-${company.business_name || company.name || ''}`);
                    if (company.business_name) dataLines.push(`Razão: ${company.business_name}`);
                    if (company.name) dataLines.push(`Nome Fantasia: ${company.name}`);
                    if (company.cnpj) dataLines.push(`CNPJ: ${company.cnpj}`);
                    
                    // Endereço
                    if (company.address) {
                      const endereco = `${company.address}${company.number ? `, ${company.number}` : ''}${company.district ? ` - ${company.district}` : ''}`;
                      dataLines.push(`Endereço: ${endereco}`);
                    }
                    if (company.city || company.state) {
                      dataLines.push(`Cidade/UF: ${company.city || ''}${company.state ? `/${company.state}` : ''}${company.zip_code ? ` - CEP: ${company.zip_code}` : ''}`);
                    }
                    
                    // Classificação
                    if (company.classificacao || company.classification) {
                      dataLines.push(`Classificação: ${company.classificacao || company.classification}`);
                    }
                    
                    // Contato
                    if (client.name) dataLines.push(`Contato: ${client.name}`);
                    if (client.email) dataLines.push(`Email: ${client.email}`);
                    if (company.phone) {
                      dataLines.push(`Telefone: (${company.area_code || ''}) ${company.phone}`);
                    }
                    
                    // Situação
                    if (company.active) {
                      const situacao = company.active === 'S' ? 'Ativo' : 
                                      company.active === 'N' ? 'Bloqueado' : 
                                      company.active === 'C' ? 'Cancelado' : 
                                      company.active === 'T' ? 'Inativo' : 'Desconhecido';
                      dataLines.push(`Situação: ${situacao}`);
                    }
                    
                    // Informações Financeiras
                    if (canViewFinancialInfo && (company.valor_mensalidade || company.valor_modulos || company.valor_desconto)) {
                      const mensalidade = parseFloat(company.valor_mensalidade || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                      const modulos = parseFloat(company.valor_modulos || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                      const desconto = parseFloat(company.valor_desconto || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                      const total = (parseFloat(company.valor_mensalidade || 0) + parseFloat(company.valor_modulos || 0) - parseFloat(company.valor_desconto || 0)).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                      
                      dataLines.push(`Fatura: Mensalidade: R$ ${mensalidade}  Módulos: R$ ${modulos}  Desconto: R$ ${desconto}  Total: R$ ${total}`);
                      if (company.dia_pagamento) dataLines.push(`Dia Pagamento: ${company.dia_pagamento}`);
                    }
                    
                    // Representante
                    if (company.service_group_description) {
                      dataLines.push(`Representante: ${company.service_group_description}`);
                    }
                    
                    // Produto/Versão
                    if (company.product_description || company.version_in_use) {
                      dataLines.push(`Produto: ${company.product_description || ''}${company.version_in_use ? `    Versão: ${company.version_in_use}` : ''}`);
                    }
                    
                    // Módulos Ativos
                    if (company.active_modules) {
                      try {
                        const modulos = typeof company.active_modules === 'string' 
                          ? JSON.parse(company.active_modules) 
                          : company.active_modules;
                        if (Array.isArray(modulos) && modulos.length > 0) {
                          dataLines.push(`Módulos: ${modulos.join(', ')}`);
                        } else {
                          dataLines.push(`Módulos: Não há módulos ativos`);
                        }
                      } catch (e) {
                        if (company.active_modules) {
                          dataLines.push(`Módulos: ${company.active_modules}`);
                        }
                      }
                    }
                    
                    // Versão
                    if (company.version_in_use) {
                      dataLines.push(`Versão: Licenciada: ${company.version_in_use}${company.sync_date ? `    ${new Date(company.sync_date).toLocaleDateString('pt-BR')}` : ''}`);
                    }
                    
                    // Acesso
                    if (company.usuario_site || company.senha_site) {
                      dataLines.push(`Acesso: Usuário: ${company.usuario_site || ''}    Senha: ${company.senha_site || ''}`);
                    }
                    
                    // Sincronização
                    if (company.sync_date) {
                      const syncDate = new Date(company.sync_date);
                      dataLines.push(`Sincronização: Última sincronização webservice sysfar: ${syncDate.toLocaleString('pt-BR')}`);
                    }
                    
                    // Aplicação
                    if (company.product_description) {
                      dataLines.push(`Aplicação: ${company.product_description}`);
                    }
                    
                    const text = dataLines.filter(line => line.trim()).join('\n');
                    
                    if (navigator.clipboard?.writeText) {
                      navigator.clipboard.writeText(text);
                    }
                  }}
                >
                  Copiar dados
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => setClientSearchOpen(false)}
                >
                  Fechar
                </Button>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

// export default Template;

const mapStateToProps = state => {
  const { rooms } = state;
  const { inProgressRooms } = rooms;
  return { inProgressRooms, };
};

const mapDispatchToProps = dispatch => ({
  getInProgressRooms: operatorId => dispatch(getInProgressRooms(operatorId)),
  getUserIndicators: () => dispatch(getUserIndicators()),
  getUsers: () => dispatch(getUsers()),
  getServiceGroups: () => dispatch(getServiceGroups()),
  getUser: (id) => dispatch(getUser(id)),
  getProfiles: () => dispatch(getProfiles()),
  setPermissions: (permissions) => dispatch(setPermissions(permissions)),
  logOut: () => dispatch(logOut()),
  setLoading: () => dispatch(setLoading()),
  setNotLoading: () => dispatch(setNotLoading()),
  fetchFields: () => dispatch(fetchFields()),

});

export default connect(mapStateToProps, mapDispatchToProps)(Template);